var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 9 2 C 7.346 2 6 3.346 6 5 C 6 5.3523906 6.0714373 5.6856091 6.1835938 6 L 2 6 L 2 12 L 3 12 L 3 19.087891 C 3 20.142891 3.8571094 21 4.9121094 21 L 19.087891 21 C 20.142891 21 21 20.142891 21 19.087891 L 21 12 L 22 12 L 22 6 L 17.816406 6 C 17.928563 5.6856091 18 5.3523906 18 5 C 18 3.346 16.654 2 15 2 C 14.229288 2 13.531943 2.2998104 13 2.7792969 L 13 2.765625 L 12.921875 2.84375 C 12.895215 2.8694499 12.86945 2.8952145 12.84375 2.921875 L 12 3.765625 L 11.15625 2.921875 C 11.13055 2.8952145 11.104785 2.8694499 11.078125 2.84375 L 11 2.765625 L 11 2.7792969 C 10.468057 2.2998104 9.7707122 2 9 2 z M 9 4 C 9.552 4 10 4.449 10 5 C 10 5.551 9.552 6 9 6 C 8.448 6 8 5.551 8 5 C 8 4.449 8.448 4 9 4 z M 15 4 C 15.552 4 16 4.449 16 5 C 16 5.551 15.552 6 15 6 C 14.448 6 14 5.551 14 5 C 14 4.449 14.448 4 15 4 z M 4 8 L 20 8 L 20 10 L 4 10 L 4 8 z M 5 12 L 11 12 L 11 19 L 5 19 L 5 12 z M 13 12 L 19 12 L 19 19 L 13 19 L 13 12 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBtn);
export default __webpack_public_path__ + "static/media/giftBtn.36e37a5a82262ec9391d5d08eb5b98d7.svg";
export { ForwardRef as ReactComponent };